export default __webpack_public_path__ + "static/media/7.793e56a6.png";